<template>
  <el-dialog title="编辑传感器" :visible.sync="visible" @opened="openDialog" class="temperatureDialog" @close="closeDialog"
    :modal-append-to-body="false" :close-on-click-modal="false" :class="visible ? 'flip-in-hor-bottom' : ''">
    <div>
      <div class="edit-sensor-body">
        <!-- <span class="pane-title">编辑传感器</span> -->
        <el-form v-if="form1.sensorType == 10" label-position="left" label-width="7rem" :model="form1" :inline="true"
          :rules="rules" style="margin-left: 30px; margin-top: 30px; margin-right: 30px" ref="ruleForm">
          <el-form-item label="传感器类型：" prop="sensorType">
            <el-select v-model="form1.sensorType" clearable placeholder="请选择">
              <el-option v-for="item in TypeOptions" :key="item.value" :label="item.label" :value="item.value"
                style="width: 225px">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="线路序号：" prop="sensorId" style="margin-left: 50px">
            <el-input v-model="form1.orderNum" style="width: 225px"></el-input>
          </el-form-item>

          <div />

          <el-form-item label="监测位置：" prop="position">
            <el-input v-model="form1.position"></el-input>
          </el-form-item>
          <div />

          <el-divider>参考值</el-divider>
          <el-form-item label="预警温度值：" prop="earlyWarningTemper">
            <el-input v-model="form1.earlyWarningTemper" style="width: 225px"></el-input>
          </el-form-item>
          <el-form-item label="告警温度值" prop="warningTemper" style="margin-left: 50px">
            <el-input v-model="form1.warningTemper" style="width: 225px"></el-input>
          </el-form-item>
          <div />
        </el-form>
        <el-form v-else label-position="left" label-width="7rem" :model="form1" :inline="true" :rules="rules"
          style="margin-left: 30px; margin-top: 30px; margin-right: 30px" ref="ruleForm">
          <el-form-item label="传感器编号：" prop="sensorId">
            <el-input v-model="form1.sensorId" style="width: 225px"></el-input>
          </el-form-item>

          <el-form-item label="传感器类型：" prop="sensorType" style="margin-left: 50px">
            <el-select v-model="form1.sensorType" clearable placeholder="请选择">
              <el-option v-for="item in TypeOptions" :key="item.value" :label="item.label" :value="item.value"
                style="width: 225px">
              </el-option>
            </el-select>
          </el-form-item>
          <div />
          <el-form-item label="USB端口：" prop="usbPort">
            <el-input v-model="form1.usbPort" style="width: 225px"></el-input>
          </el-form-item>
          <el-form-item label="监测位置：" prop="position" style="margin-left: 50px">
            <el-input v-model="form1.position"></el-input>
          </el-form-item>
          <div />
          <el-form-item label="分区：" prop="location">
            <el-select v-model="form1.location" clearable placeholder="请选择">
              <el-option v-for="item in locationOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-divider>参考值</el-divider>
          <el-form-item label="参考值" prop="a95">
            <el-input v-model="form1.a95" style="width: 225px"></el-input>
          </el-form-item>
          <el-form-item label="预警倍数：" prop="earlyWarningFactor" style="margin-left: 50px">
            <el-input v-model="form1.earlyWarningFactor" style="width: 225px"></el-input>
          </el-form-item>
          <div />

          <el-form-item label="告警倍数：" prop="warningFactor">
            <el-input v-model="form1.warningFactor" style="width: 225px"></el-input>
          </el-form-item>

          <el-form-item label="计算范围：" prop="a95Range" style="margin-left: 50px">
            <el-input v-model="form1.a95Range" style="width: 225px"></el-input>
          </el-form-item>
          <div />

          <el-form-item label="开始计算时间：" prop="a95StartTime">
            <el-input v-model="form1.a95StartTime" :disabled="true" style="width: 225px"></el-input>
          </el-form-item>
          <el-form-item label="结束计算时间：" prop="a95EndTime" style="margin-left: 50px">
            <el-input v-model="form1.a95EndTime" :disabled="true" style="width: 225px"></el-input>
          </el-form-item>

          <el-form-item label="更新规则：" prop="a95Type" style="display: block;">
            <el-select v-model="form1.a95Type" clearable placeholder="请选择">
              <el-option v-for="item in a95TypeOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div style="text-align: center;">
          <button class="btn3" @click="add('ruleForm')">确定</button>
          <button class="btn4" @click="closeDialog">取消</button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import commonUtils from "@/utils/common";
import datePicker from "@/components/datePicker.vue";
import Pagination from "@/components/Pagination.vue";
export default {
  components: { datePicker, Pagination },
  data() {
    return {
      activeTab: "表格1", // 当前选中的选项卡
      activeStep: 0,
      visible: false,
      lineChartDataX: [],
      lineChartDataY: [],
      lightedPoint: [],
      form1: {
        edgeId: "",
        position: "",
        sensorType: "",
        usbPort: "",
        location: "",
        sensorId: "",
        a95StartTime: "",
        a95EndTime: "",
        a95: "",
        a95Type: '',
      },
      rules: {
        position: [
          { required: true, message: "监测位置不能为空", trigger: "blur" },
        ],
        earlyWarningTemper: [
          { required: true, message: "预警温度值不能为空", trigger: "blur" },
        ],
        sensorType: [
          { required: true, message: "请选择传感器类型", trigger: "change" },
        ],
      },
      value1: new Date(),
      maxTime: commonUtils.timeFormat(new Date()),
      minTime: commonUtils.timeFormat(
        new Date(new Date().getTime() - 3600 * 24 * 1000)
      ),
      dateValue: [
        commonUtils.timeFormat(
          new Date(new Date().getTime() - 3600 * 24 * 1000)
        ),
        commonUtils.timeFormat(new Date()),
      ],
      options: [
        {
          value: "1",
          label: "声纹传感器",
        },
        {
          value: "2",
          label: "位移传感器",
        },
      ],
      a95TypeOptions: [
        {
          value: 1,
          label: "每天凌晨12点更新",
        },
        {
          value: 2,
          label: "根据工况更新",
        },
      ],
      TypeOptions: [
        // {
        //     value: "1",
        //     label: "声纹传感器",
        //   },
        //   {
        //     value: "2",
        //     label: "位移传感器",
        //   },
        //   {
        //     value: 8,
        //     label: "新版声纹传感器",
        //   },

        {
          value: 8,
          label: "声纹传感器",
        },
        {
          value: 10,
          label: "温度传感器",
        },
      ],
      locationOptions: [
        {
          value: 1,
          label: "上半区",
        },
        {
          value: 2,
          label: "下半区",
        },
        {
          value: null,
          label: "无分区",
        },
      ],
      total: 100,
      pageNo: 1,
      pageSize: 10,
    };
  },
  methods: {
    add(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params =
            this.form1.sensorType == 10
              ? {
                edgeId: this.$store.state.curEdgeId,
                position: this.form1.position,
                sensorType: this.form1.sensorType,
                id: this.form1.id,
                order: this.form1.orderNum,
                earlyWarningTemper: this.form1.earlyWarningTemper,
                warningTemper: this.form1.warningTemper,
                usbPort: 106,
              }
              : {
                edgeId: this.$store.state.curEdgeId,
                position: this.form1.position,
                sensorType: this.form1.sensorType,
                usbPort: this.form1.usbPort,
                id: this.form1.id,
                location: this.form1.location,
                a95Type: this.form1.a95Type,
                earlyWarningFactor: this.form1.earlyWarningFactor,
                warningFactor: this.form1.warningFactor,
                a95Range: this.form1.a95Range,
                sensorId: this.form1.sensorId,
                a95: this.form1.a95,
              };
          this.$api.sensor.edit(params).then((res) => {
            if (res.code == 200) {
              this.$emit("getsensorList");
              this.$alert("修改传感器成功", "", {
                confirmButtonText: "确定",
                type: "success",
                center: true,
              }).then((action) => {
                if (action === "confirm") {
                  this.visible = false;
                }
              });
            } else {
              this.$alert(res.msg, "", {
                confirmButtonText: "确定",
                type: "warning",
                center: true,
              }).then((action) => {
                if (action === "confirm") {
                  this.visible = false;
                }
              });
            }
          });
        } else {
          // alert('submit!');

          this.$alert("请将参数填写完整", "", {
            confirmButtonText: "确定",
            type: "warning",
            center: true,
          }).then((action) => {
            if (action === "confirm") {
              this.visible = false;
            }
          });
          return false;
        }
      });
    },
    // nextStep() { // 下一步按钮点击事件处理函数
    //   if (this.activeStep < 3) {
    //     this.activeStep += 1;
    //     this.activeTab = `表格${this.activeStep + 1}`; // 切换到下一个选项卡
    //     if (this.activeStep == 3)
    //     { this.activeStep = 0;}
    //   }},
    finishStep() {
      this.activeStep = 3;
    },
    nextStep() {
      if (this.activeStep++ > 2) this.activeStep = 0;
      if (this.activeStep < 3) {
        console.log(this.activeStep);
        this.activeTab = `表格${this.activeStep + 1}`; // 切换到下一个选项卡
      } else {
        this.activeTab = `表格${3}`;
      }
    },
    openDialog() { },
    closeDialog() {
      this.visible = false;
    },
    //选择时间
    confirmDate(min, max) {
      if (min) {
        //选择时间
        this.maxTime = max;
        this.minTime = min;
      } else {
        //清空时间，取默认
        this.dateValue = [
          new Date(new Date().getTime() - 3600 * 24 * 1000),
          new Date(),
        ];

        this.maxTime = commonUtils.timeFormat(new Date());
        this.minTime = commonUtils.timeFormat(
          new Date(new Date().getTime() - 3600 * 24 * 1000)
        );
      }
    },
  },
};
</script>

<style lang="less" scoped>
.temperatureDialog {
  /deep/ .el-dialog__title {
    font-size: 1.5rem;
  }

  /deep/ .el-input__inner {
    border: 1px solid #c0e9ff1f;
    background: var(--input-bg);
    color: var(--titleName-color);
    border-radius: 0px;
  }

  /deep/ .el-form-item__label {
    font-size: 0.875rem;
  }

  //   /deep/ .el-select {
  //     width: 215px;
  //   }
  //   /deep/ .el-select-dropdown__wrap.el-scrollbar__wrap {
  //     overflow: auto;
  //     background-color: #244447;
  //     border: none;
  //   }
  //   /deep/ .el-select-dropdown {
  //     border: none;
  //   }
  //   /deep/ .el-select-dropdown__item.hover,
  //   .el-select-dropdown__item:hover {
  //     color: #d3fbff;
  //     background-color: #3f98a0;
  //   }

  //   /deep/ .el-select-dropdown__item.selected {
  //     color: #d3fbff;
  //   }
  //   /deep/ .el-select-dropdown__item {
  //     color: rgba(255, 255, 255, 0.603);
  //   }

  //   /deep/.el-dialog__body {
  //     // padding: 25px 20px !important;
  //     color: #ffffff;
  //     background: #182732;
  //   }

  //   /deep/ .el-dialog {
  //     background: #344142ec;
  //     width: 55rem;
  //     // height: 43.75rem;
  //   }

  //   /deep/ .pagination-container {
  //     text-align: center;
  //   }
  //   /deep/ .el-textarea__inner {
  //     width: 31.25rem;
  //     height: 8rem;
  //     color: white;
  //     border-radius: 0.25rem;
  //     border: 0.1875rem solid #c0e9ff1f;
  //     background: #24444757;
  //     border-radius: 0px;
  //     font-size: 0.875rem;
  //   }
  //   /deep/ .el-textarea__inner:focus {
  //     border-color: #55b1b1 !important;
  //   }
}

//添加动画
.flip-in-hor-bottom {
  animation: flip-in-hor-bottom 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@keyframes flip-in-hor-bottom {
  0% {
    transform: rotateX(80deg);
    opacity: 0;
  }

  100% {
    transform: rotateX(0);
    opacity: 1;
  }
}

.btn3 {
  width: 8.125rem;
  height: 1.875rem;
  background: #219e82;
  border-radius: 0.125rem;
  border: 0.0625rem solid #219e82;
  color: white;
  font-size: 0.875rem;
  cursor: pointer;
  margin: 1.875rem 1.25rem;
}

.btn3:hover {
  background: #44d7b6;
}

.btn4 {
  width: 8.125rem;
  height: 1.875rem;
  border-radius: 0.125rem;
  border: 0.0625rem solid #44d7b6;
  background: transparent;
  color: #44d7b6;
  font-size: 0.875rem;
  cursor: pointer;
  margin: 1.875rem 1.25rem;
}

.btn4:hover {
  background: #44d7b655;
}

.pane-title {
  padding-left: 30px;
  font-size: 21px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #5bb3bc;
  line-height: 32px;
}

.edit-sensor-body {
  .el-divider__text {
    background-color: rgb(17, 32, 38) !important;
    color: #fff !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/equip/sensor/editSensorDialog.vue